import { Button, Tooltip } from '@design-system';
import { useTranslation } from 'next-i18next';
import { useRef } from 'react';

type Props = {
  isSubscribed: boolean;
  loading?: boolean;
  onClickSubscribe?: () => Promise<void>;
};

const SubscribeBell: React.FC<Props> = ({
  isSubscribed,
  loading,
  onClickSubscribe,
}) => {
  const { t } = useTranslation('common');
  const linkRef = useRef<HTMLAnchorElement>(null);

  return (
    <>
      <Button
        ref={linkRef}
        disabled={isSubscribed || loading}
        hideLabel
        icon={
          isSubscribed ? 'ic_notification_active' : 'ic_notification_outline'
        }
        label={
          isSubscribed
            ? t('tooltips.subscribed')
            : t('tooltips.subscribeToArtist')
        }
        loading={loading}
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault();
          void onClickSubscribe?.();
        }}
        size="sm"
        variant={isSubscribed ? 'positive' : 'tertiary'}
      />
      <Tooltip parentRef={linkRef} selectionRef={linkRef}>
        {isSubscribed
          ? t('tooltips.subscribed')
          : t('tooltips.subscribeToArtist')}
      </Tooltip>
    </>
  );
};

export default SubscribeBell;
